// src/utils/initializeNotifications.js
import { setupNotificationEventListeners } from './eventListeners';
import NotificationBatch from './notificationBatch';
import { cleanupOldNotifications, getUnreadNotificationsCount } from '../services/notificationsService';

/**
 * Inicializa el sistema de notificaciones en la aplicación
 * @param {Function} setUnreadCount - Función para actualizar el contador de no leídas
 * @returns {Object} Objetos de limpieza para cancelar suscripciones
 */
export const initializeNotifications = (setUnreadCount = null) => {
  console.log('Inicializando sistema de notificaciones...');
  
  // Establecer escuchas de eventos de Supabase
  const channels = setupNotificationEventListeners();
  
  // Iniciar limpieza periódica
  const cleanupInterval = setInterval(async () => {
    try {
      console.log('Ejecutando limpieza periódica de notificaciones antiguas...');
      const result = await cleanupOldNotifications();
      
      if (result.success) {
        console.log(`Limpieza periódica: ${result.count} notificaciones antiguas eliminadas`);
      } else {
        console.error('Error en limpieza periódica:', result.error);
      }
    } catch (error) {
      console.error('Error ejecutando limpieza periódica:', error);
    }
  }, 1000 * 60 * 60 * 24); // Una vez al día
  
  // Actualizar contador periódicamente si se proporciona la función setUnreadCount
  let updateCountInterval = null;
  
  if (setUnreadCount && typeof setUnreadCount === 'function') {
    // Actualizar inmediatamente
    updateUnreadCount(setUnreadCount);
    
    // Configurar actualización periódica
    updateCountInterval = setInterval(() => {
      updateUnreadCount(setUnreadCount);
    }, 1000 * 60 * 5); // Cada 5 minutos
  }
  
  // Devolver función de limpieza
  return {
    cleanup: () => {
      // Cancelar suscripciones a canales
      Object.values(channels).forEach(channel => {
        if (channel && typeof channel.unsubscribe === 'function') {
          channel.unsubscribe();
        }
      });
      
      // Limpiar intervalos
      clearInterval(cleanupInterval);
      
      if (updateCountInterval) {
        clearInterval(updateCountInterval);
      }
      
      console.log('Sistema de notificaciones desconectado');
    }
  };
};

/**
 * Actualiza el contador de notificaciones no leídas
 * @param {Function} setUnreadCount - Función para actualizar el contador
 */
const updateUnreadCount = async (setUnreadCount) => {
  try {
    const count = await getUnreadNotificationsCount();
    setUnreadCount(count);
  } catch (error) {
    console.error('Error actualizando contador de notificaciones:', error);
  }
};